import { MoreVert as MoreVertIcon, ReceiptLongOutlined, VisibilityOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { InstallmentRowMenu } from "../../agreements/components/InstallmentRowMenu";
import { ModalAgreementInstallments } from "../../agreements/components/Modals/ModalAgreementInstallments";
import { IAgreement, SinisterAgreementService } from "../../../shared/services/api/sinister/SinisterAgreementService";
import { ICollectionControlRow } from "../hooks/useCollectionControlInstallments";
import { ModalCollectionInstallmentDetails } from "./Modals/ModalCollectionInstallmentDetails";

interface Props {
	row: ICollectionControlRow;
	onChanged: () => void;
}

// Reaproveita o InstallmentRowMenu inteiro (mesmas ações da tela de detalhes do acordo: baixa manual,
// cancelar, consultar/gerar 2ª via, reenviar boleto, ver histórico, registrar/ver repasse), só
// acrescentando dois itens próprios desta tela: "Ver detalhes da parcela" (contexto de
// certificado/cliente que a consolidada tem e o acordo sozinho não mostra) e "Ver Parcelas do Acordo"
// (mesma ModalAgreementInstallments já usada na listagem de Acordos — como aqui cada linha é UMA
// parcela, isso dá acesso rápido a todas as parcelas do mesmo acordo sem sair da tela).
//
// GET /sinister-agreements/installments (PR-10) não devolve o acordo inteiro (status/installmentHistory),
// só `agreementId` — InstallmentRowMenu precisa do acordo completo pra gate de permissão (agreement.status
// !== "broken") e pro histórico da parcela, então buscamos via getById, uma vez por linha visível na
// página (bounded pelo rowsPerPage da tabela, não por todo o volume de acordos).
export function CollectionControlRowMenu({ row, onChanged }: Props) {
	const [openDetailsModal, setOpenDetailsModal] = useState(false);
	const [openInstallmentsModal, setOpenInstallmentsModal] = useState(false);
	const [agreement, setAgreement] = useState<IAgreement | null>(null);

	useEffect(() => {
		let active = true;
		setAgreement(null);
		SinisterAgreementService.getById(row.agreementId).then((result) => {
			if (active && !(result instanceof Error)) setAgreement(result);
		});
		return () => {
			active = false;
		};
	}, [row.agreementId]);

	if (!agreement) {
		return (
			<IconButton size="small" disabled aria-label="Ações da parcela">
				<MoreVertIcon fontSize="small" />
			</IconButton>
		);
	}

	return (
		<>
			<InstallmentRowMenu
				agreement={agreement}
				installment={row.installment}
				onChanged={onChanged}
				extraMenuItems={[
					{ label: "Ver detalhes da parcela", icon: <VisibilityOutlined fontSize="small" />, onClick: () => setOpenDetailsModal(true) },
					{
						label: "Ver Parcelas do Acordo",
						icon: <ReceiptLongOutlined fontSize="small" />,
						onClick: () => setOpenInstallmentsModal(true),
					},
				]}
			/>

			<ModalCollectionInstallmentDetails open={openDetailsModal} row={row} onClose={() => setOpenDetailsModal(false)} />
			<ModalAgreementInstallments open={openInstallmentsModal} agreementId={row.agreementId} onClose={() => setOpenInstallmentsModal(false)} />
		</>
	);
}
